import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const boardblendApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
  endpoints: () => ({}),
  reducerPath: "boardblendApi",
  tagTypes: [
    "AccountSessions",
    "Artifacts",
    "Billing",
    "Comments",
    "Context",
    "Mcp",
    "Session",
    "Workshop",
    "Transcription",
  ],
});

export function getApiErrorMessage(error: unknown, fallback: string) {
  if (!error || typeof error !== "object") return fallback;

  if ("data" in error) {
    const data = error.data;
    if (data && typeof data === "object" && "error" in data) {
      return typeof data.error === "string" ? data.error : fallback;
    }
  }

  if ("message" in error && typeof error.message === "string") {
    return error.message;
  }

  return fallback;
}

export function getApiErrorCode(error: unknown) {
  if (!error || typeof error !== "object" || !("data" in error)) return;
  const data = error.data;
  if (!data || typeof data !== "object" || !("code" in data)) return;
  return typeof data.code === "string" ? data.code : undefined;
}
